/**
 * ReportMarkdown — lazy boundary around the markdown renderer.
 *
 * react-markdown + the remark/micromark ecosystem is heavy and only needed on
 * screens that actually show a report (compat result, natal reading, etc.), so
 * the implementation lives in ReportMarkdownInner and is code-split out of the
 * initial bundle via React.lazy. All call sites stay unchanged.
 */
import { lazy, Suspense, type ReactNode } from 'react';

const ReportMarkdownInner = lazy(() => import('./ReportMarkdownInner'));

export function ReportMarkdown({ markdown, fallback = null }: { markdown: string; fallback?: ReactNode }): JSX.Element {
  return (
    <Suspense fallback={fallback}>
      <ReportMarkdownInner markdown={markdown} />
    </Suspense>
  );
}
